import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '@core/services/auth.service';

@Injectable({
    providedIn: 'root',
})
export class FirstLoginPasswordChangeGuard implements CanActivate {
    constructor(private router: Router, private authService: AuthService) {}

    canActivate(): Observable<boolean> | boolean {
        return this.authService.requiresPasswordChange().pipe(
            map(response => {
                if (response.requiresPasswordChange) {
                    this.router.navigateByUrl('first-password');
                    return false;
                }
                return true;
            }),
            catchError(error => {
                return of(true);
            })
        );
    }
}
